import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import HomeScreen from './Screens/HomeScreen';
import Solutions from './Screens/Solutions';
import BlogScreen from './Screens/BlogScreen';
import TryDemoScreen from './Screens/TryDemoScreen';
import WhyUseScreen from './Screens/WhyUseScreen';
import CompanyScreen from './Screens/CompanyScreen';
import PostDetail from './Components/PostDetail';
import SecondHeader from './Components/SecondHeader/SecondHeader';
import Footer from './Components/Footer/Footer';
import EbookScreen from './Screens/EbookScreen';
import LogoExample from './Components/LogoExample';
import PrivacyPolicyScreen from './Screens/PrivacyPolicyScreen';
import TermsAndConditionsScreen from './Screens/TermsAndConditionsScreen';
import CookiesPolicyScreen from './Screens/CookiesPolicyScreen';
import CookieConsent from './Components/CookieConsent/CookieConsent';
import MetaPixelLoader from './MetaPixelLoader';
import MetaPixelTracker from './MetaPixelTracker';  

const App = () => {
  return (
    <Router>  
      <MetaPixelLoader />
      <MetaPixelTracker />
      <SecondHeader />
      <main>
        <Routes>
          <Route path="/" element={<HomeScreen />} exact />
          <Route path="/solutions" element={<Solutions />} exact />
          <Route path="/blog" element={<BlogScreen />} exact />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/demo" element={<TryDemoScreen />} exact />
          <Route path="/whyuse" element={<WhyUseScreen />} exact />
          <Route path="/company" element={<CompanyScreen />} exact />
          <Route path="/ebook" element={<EbookScreen />} exact />
          <Route path="/logo" element={<LogoExample />} exact />
          <Route path="/politika-privatnosti" element={<PrivacyPolicyScreen />} exact />
          <Route path="/uslovi-koriscenja" element={<TermsAndConditionsScreen />} exact />
          <Route path="/kolacici" element={<CookiesPolicyScreen />} exact />

        </Routes>
        <Footer />
        <CookieConsent />
      </main>
    </Router>
  );
}

export default App;
